import { useWheels } from "../../../../../logic/hooks/useWheels";
import { wheelLauncher } from "../../../../../logic/helpers/wheel";
import {
    MainPageLaunchers,
    type MainPageLaunchersProps,
} from "../MainPageLaunchers/MainPageLaunchers";

export function BackendMainPageLaunchers(
    props: Omit<MainPageLaunchersProps, "wheels">,
) {
    const { wheels } = useWheels({ exposeVisibleCampaigns: true });
    return <MainPageLaunchers {...props} wheels={wheels.map(wheelLauncher)} />;
}
